import React, { useState, useEffect, useMemo } from 'react';
import { useAuth } from '../../hooks/auth';
import { ContentHeader } from '../../components/ContentHeader';
import DuvidasButton from '../../components/DuvidasButton';
import { debounce } from '../../components/funcoes';
import { toastWarning } from '../../toasts';
import EditarCadastrarMensagem from './EditarCadastrar';
import { Container, Divider, InputGroup, Table } from 'rsuite';
import PlusIcon from '@rsuite/icons/Plus';
import api from '../../services/api';
import SearchIcon from '@rsuite/icons/Search';
import { ContainerInterno, ContainerStyled } from './styles';
import { useCustomTheme } from '../../hooks/useCustomTheme';
import { CustomInput } from '../../components/CustomInput';
import { CustomButton } from '../../components/CustomButton';
import { CustomSelectPicker } from '../../components/CustomSelectPicker';
import { CustomCell } from '../../components/CustomCell';
import { CustomHeaderCell } from '../../components/CustomHeaderCell';
import { FaRegIdCard } from 'react-icons/fa';

const data = [
  { value: 'sans-serif', label: 'Sans-serif' },
  { value: 'Arial', label: 'Arial' },
  { value: 'fantasy', label: 'Fantasy' },
  { value: 'serif', label: 'Serif' },
  { value: 'Franklin Gothic Medium', label: 'Franklin Gothic Medium' },
  { value: 'Poppins', label: 'Poppins' },
  { value: 'Sofia', label: 'Sofia' },
  { value: 'Meie Script', label: 'Meie Script' },
  { value: 'Sonsie One', label: 'Sonsie One' },
  { value: 'Yesteryear', label: 'Yesteryear' },
];

const dataTamanho = [
  { value: '10px', label: '10px' },
  { value: '12px', label: '12px' },
  { value: '14px', label: '14px' },
  { value: '16px', label: '16px' },
  { value: '18px', label: '18px' },
  { value: '20px', label: '20px' },
  { value: '22px', label: '22px' },
  { value: '24px', label: '24px' },
  { value: '26px', label: '26px' },
  { value: '28px', label: '28px' },
  { value: '30px', label: '30px' },
  { value: '32px', label: '32px' },
  { value: '34px', label: '34px' },
  { value: '36px', label: '36px' },
  { value: '38px', label: '38px' },
  { value: '40px', label: '40px' },
];

const { Column } = Table;

export default function CartaoVisita() {
  const { id_empresa } = useAuth();
  const [modalCadastrarEditar, setModalCadastrarEditar] = useState(false);
  const [IdMensagem, setIdMensagem] = useState('');
  const [mensagens, setMensagens] = useState([]);
  const [objMensagem, setObjMensagem] = useState(null);
  const [loading, setLoading] = useState(false);
  const [fonte, setFonte] = useState('sans-serif');
  const [tamanho, setTamanho] = useState('10px');
  const [quantidade, setQuantidade] = useState(1);
  const [empresa, setEmpresa] = useState(null);
  const { theme } = useCustomTheme();

  const [busca, setBusca] = useState('');

  const mensagensMemo = useMemo(
    () =>
      busca.trim() === ''
        ? mensagens
        : mensagens.filter(
            ({ Titulo = '', Mensagem = '' }) =>
              Titulo?.toLocaleLowerCase().includes(busca) ||
              Mensagem?.toLocaleLowerCase().includes(busca),
          ),
    [busca, mensagens],
  );

  const dataMensagem = mensagens.map((item) => ({
    label: item.Titulo,
    value: item.Mensagem,
  }));

  const imprimirCartao = () => {
    if (IdMensagem) {
      if (quantidade > 0) {
        let dados = JSON.stringify({
          mensagem: IdMensagem,
          quantidade: quantidade,
          empresa: empresa,
          fonte: fonte,
          tamanho: tamanho,
        });
        localStorage.setItem('visit-card-data', dados);
        window.open(
          `/g_imprimir_cartao/`,
          'minhaJanela',
          'height=800,width=800',
        );
      } else {
        toastWarning('Quantidade incorreta');
      }
    } else {
      toastWarning('Informe a mensagem');
    }
  };

  const atualizar = async () => {
    setLoading(true);
    api
      .get(`empresa/encontrar/${id_empresa}`)
      .then((res) => {
        setEmpresa(res.data);
      })
      .catch((error) => console.log({ error }))
      .finally(() => {
        setLoading(false);
      });
    api
      .get(`mensagem-cartao-visita/listar/${id_empresa}`)
      .then((res) => {
        setLoading(false);
        res.data.length > 0 ? setMensagens(res.data) : setMensagens([]);
      })
      .catch((error) => console.log({ error }))
      .finally(() => {
        setLoading(false);
      });
  };

  const cadastrar = () => {
    setObjMensagem(null);
    setModalCadastrarEditar(true);
  };

  const abrirDados = (obj) => {
    setObjMensagem(obj);
    setModalCadastrarEditar(true);
  };

  const debounceSearch = debounce((valor = '') => {
    setBusca(valor.toLocaleLowerCase());
  }, 1000);

  useEffect(() => {
    atualizar();
  }, []);

  return (
    <Container
      style={{
        padding: '10px',
        height: 'calc(100vh - 60px)',
        backgroundColor: theme.colors.background,
      }}
    >
      <ContentHeader
        title="Cartão de Visita"
        subtitle="Gerencie as mensagens do cartão de visita da sua empresa"
        icon={FaRegIdCard}
        secondComponent={
          <InputGroup inside style={{ width: '36vw', border: 'none' }}>
            <CustomInput onChange={debounceSearch} />
            <InputGroup.Addon>
              <SearchIcon color={theme.colors.textSecondary} />
            </InputGroup.Addon>
          </InputGroup>
        }
        thirdComponent={
          <>
            <DuvidasButton tela="cartao-visita" />
            <CustomButton appearance="primary" onClick={() => cadastrar()}>
              <PlusIcon style={{ marginRight: 6 }} /> Cadastrar
            </CustomButton>
          </>
        }
      />

      <form
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <ContainerStyled style={{ margin: 0, padding: '0 10px' }}>
          <ContainerInterno>
            <label
              htmlFor="Mensagem"
              style={{ marginLeft: 6, color: theme.colors.textSecondary }}
            >
              Mensagem
            </label>
            <CustomSelectPicker
              data={dataMensagem}
              style={{ width: 200 }}
              onChange={setIdMensagem}
            />
          </ContainerInterno>
          <ContainerInterno>
            <label
              htmlFor="quantidade"
              style={{ marginLeft: 6, color: theme.colors.textSecondary }}
            >
              Estilo da Fonte
            </label>
            <CustomSelectPicker
              data={data}
              style={{ width: 200 }}
              onChange={setFonte}
            />
          </ContainerInterno>
          <ContainerInterno>
            <label
              htmlFor="quantidade"
              style={{ marginLeft: 6, color: theme.colors.textSecondary }}
            >
              Tamanho da Fonte
            </label>
            <CustomSelectPicker
              data={dataTamanho}
              style={{ width: 200 }}
              onChange={setTamanho}
            />
          </ContainerInterno>
          <ContainerInterno>
            <label
              htmlFor="quantidade"
              style={{ marginLeft: 6, color: theme.colors.textSecondary }}
            >
              Quantidade
            </label>
            <CustomInput
              type="number"
              value={quantidade}
              onChange={setQuantidade}
            />
          </ContainerInterno>
          <ContainerInterno>
            <CustomButton appearance="primary" onClick={imprimirCartao}>
              Imprimir
            </CustomButton>
          </ContainerInterno>
        </ContainerStyled>
      </form>
      <Divider
        style={{
          margin: '16px 0',
          backgroundColor: theme.colors.lightGrayOpacity,
        }}
      />
      <Table
        height={window.innerHeight - 60 - 180}
        loading={loading}
        data={mensagensMemo}
        bordered={true}
        onRowClick={(rowData) => {}}
        style={{
          overflowY: 'auto',
          borderColor: theme.colors.backgroundSecondary,
          backgroundColor: theme.colors.backgroundSecondary,
          color: theme.colors.textSecondary,
        }}
        locale={{
          emptyMessage: 'Nenhuma conta bancária encontrada',
          loading: 'Carregando...',
        }}
      >
        <Column
          style={{
            background: theme.colors.backgroundSecondary,
            color: theme.colors.textSecondary,
          }}
          fixed
        >
          <CustomHeaderCell>Codigo</CustomHeaderCell>
          <CustomCell dataKey="Id" />
        </Column>

        <Column
          style={{
            background: theme.colors.backgroundSecondary,
            color: theme.colors.textSecondary,
          }}
        >
          <CustomHeaderCell>Titulo</CustomHeaderCell>
          <CustomCell dataKey="Titulo" />
        </Column>

        <Column
          style={{
            background: theme.colors.backgroundSecondary,
            color: theme.colors.textSecondary,
          }}
          flexGrow={1}
        >
          <CustomHeaderCell>Mensagem</CustomHeaderCell>
          <CustomCell dataKey="Mensagem" />
        </Column>

        <Column
          style={{
            background: theme.colors.backgroundSecondary,
            color: theme.colors.textSecondary,
          }}
        >
          <CustomHeaderCell>Ativo</CustomHeaderCell>
          <CustomCell dataKey="Fim">
            {(rowData) => (
              <span style={{ padding: 0 }}>
                <CustomButton
                  appearance={rowData.Ativo ? 'primary' : 'ghost'}
                  style={{
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '0 10px',
                  }}
                >
                  {rowData.Ativo ? 'Sim' : 'Não'}
                </CustomButton>
              </span>
            )}
          </CustomCell>
        </Column>

        <Column
          style={{
            background: theme.colors.backgroundSecondary,
            color: theme.colors.textSecondary,
          }}
          fixed="right"
        >
          <CustomHeaderCell>Opções</CustomHeaderCell>

          <CustomCell>
            {(rowData) => (
              <>
                <CustomButton
                  color="violet"
                  appearance="ghost"
                  size="xs"
                  onClick={() => abrirDados(rowData)}
                >
                  Cartao
                </CustomButton>
              </>
            )}
          </CustomCell>
        </Column>
      </Table>

      {modalCadastrarEditar && (
        <EditarCadastrarMensagem
          open={modalCadastrarEditar}
          close={() => setModalCadastrarEditar(false)}
          objMensagem={objMensagem}
          setMensagens={setMensagens}
        />
      )}
    </Container>
  );
}
